import { CalendarIcon, GraphDownIcon, ManagerIcon, MoneyCircleIcon } from '@cash-me/react-components'
export const benefits = [
  {
    id: '1',
    icon: GraphDownIcon,
    title: 'Taxas mais baixas',
    description: 'Opções pré e pós-fixadas.'
  },
  {
    id: '2',
    icon: MoneyCircleIcon,
    title: 'Do jeito que você precisa',
    description: 'Empréstimo a partir de R$ 50 mil, com análise de crédito realizada em até 2 dias.'
  },
  {
    id: '3',
    icon: CalendarIcon,
    title: 'Prazos mais longos',
    description: `Carência de até 3 meses para pagar a primeira parcela e até 240 meses para pagar 
    o crédito.`
  },
  {
    id: '4',
    icon: ManagerIcon,
    title: 'Confiabilidade no mercado',
    description: `Somos especialistas na modalidade de crédito com garantia de imóvel de forma 
    descomplicada e segura.`
  }
]
